import "./Decision.scss";
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Radio,
} from "antd";

import { useTranslation } from "react-i18next";
import { Subsection, Paragraph } from '..'
import FormConfigBadges from '../FormConfigBadges/FormConfigBadges'

const Decision = ({ formId, client, record, section, component, mode, lang, handleChangeValues, showErrors }) => {
  const [ error, setError ] = useState(null)
  const [ comp, setComp ] = useState(JSON.parse(JSON.stringify(component)))
  const { t } = useTranslation('forms');
  const decisionRisks = Array.isArray(component.risks) ? component.risks : [];
  const risksForYes = decisionRisks.filter(item => item && item.decision === true)
  const risksForNo = decisionRisks.filter(item => item && item.decision === false)
  const showRiskBadges = mode === 'preview' && (risksForYes.length > 0 || risksForNo.length > 0)

  useEffect(() => {
    if(mode !== 'pdf' && handleChangeValues) {
      if((component.decision === null || component.decision === undefined) && mode === 'html') {
        setError(t('forms.errors.mustSelectDecision'))
      }
    }
  }, [mode])

  const handleChangeDecision = (value) => {
    refreshSectionKey('decision', value)
    setError(null)
  }

  const refreshSectionKey = (key, value, updateValues=true) => {
    let c = {...comp, [key]: value}
    setComp(c)
    handleChangeValues && handleChangeValues(c, updateValues)
  }

  const handleChangeValuesFn = (co, updateValues) => {
    let _s = comp.decision === true ? comp.compSi : comp.decision === false ? comp.compNo : null
    if(_s) {
      let _comp = []
      _s.components.map((c, i) => {
        if(c.id === co.id) {
          _comp.push(co)
        }else if(c.fieldSet && c.fieldSet.id === co.id) {
          _comp.push({ ...c, fieldSet: co })
        }else {
          _comp.push(c)
        }
      })
      _s.components = _comp
      handleChangeValues && handleChangeValues(comp, updateValues)
    }
  }

  return (
    <div className="form-manager-decision-form">
      <Row className="header-table">
        { mode !== 'pdf' && error !== null && showErrors && <Row className="has-errors-fieldset">{error}</Row>}
        <Col span={showRiskBadges ? 21 : 22} style={{textAlign: 'justify', paddingRight: (mode==='pdf' ? 10 : 0)}}>
            <Paragraph component={component} mode={mode} lang={lang} handleChangeValues={mode==="html" ? handleChangeValues:null} />
        </Col>
        <Col span={showRiskBadges ? 3 : 2}>
          { mode === "pdf" ?
            <div>
              <div>
                <input type="radio" checked={comp.decision === true} /> {t('forms.options.si')}
              </div>
              <div>
                <input type="radio" checked={comp.decision === false} /> {t('forms.options.no')}
              </div>
            </div>
            :
            <Radio.Group className="decision-risk-radio-group" value={comp.decision} onChange={(e) => mode !== 'pdf' && handleChangeDecision(e.target.value)}>
              <div className="decision-risk-option">
                <span className="decision-risk-badge">
                <FormConfigBadges
                  mode={mode}
                  risks={risksForYes}
                  riskConditionKey="decision"
                />
                </span>
                <Radio className="radio-switch" value={true}>{t('forms.options.si')}</Radio>
              </div>
              <div className="decision-risk-option">
                <span className="decision-risk-badge">
                <FormConfigBadges
                  mode={mode}
                  risks={risksForNo}
                  riskConditionKey="decision"
                />
                </span>
                <Radio className="radio-switch" value={false}>{t('forms.options.no')}</Radio>
              </div>
            </Radio.Group>
          }
        </Col>
      </Row>
      { comp.decision !== null &&
      <>
        { comp.decision === true && component.compSi && component.compSi.components && component.compSi.components.length > 0 &&
          <Subsection formId={formId} client={client} record={record} section={section} component={component} subsection={component.compSi} mode={mode} lang={lang} showErrors={showErrors} handleChangeValues={handleChangeValuesFn} />
        }
        { comp.decision === false && component.compNo && component.compNo.components && component.compNo.components.length > 0 &&
          <Subsection formId={formId} client={client} record={record} section={section} component={component} subsection={component.compNo} mode={mode} lang={lang} showErrors={showErrors} handleChangeValues={handleChangeValuesFn} />
        }
      </>
      }
    </div>
  )
}

export default Decision;
